import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { fetchCourseExercises } from '../features/courses/courseApi';

function CourseChapterMenu({ courseId }: { courseId: string }) {
  const { t } = useTranslation();
  const courseQuery = useQuery({
    queryKey: ['course-exercises', courseId],
    queryFn: () => fetchCourseExercises(courseId),
  });

  return (
    <section className="course-card__chapters" aria-labelledby={`chapters-${courseId}`}>
      <h3 id={`chapters-${courseId}`}>{t('coursesPage.chapters')}</h3>
      {courseQuery.isPending && <p role="status">{t('coursesPage.loadingChapters')}</p>}
      {courseQuery.isError && (
        <p role="alert">
          {t('coursesPage.chaptersError')} {courseQuery.error.message}
        </p>
      )}
      {courseQuery.data &&
        (courseQuery.data.chapters.length === 0 ? (
          <p>{t('coursesPage.emptyChapters')}</p>
        ) : (
          <ul className="course-card__chapter-list">
            {courseQuery.data.chapters.map((chapter) => (
              <li key={chapter.id}>
                <span>{chapter.title}</span>
                <small>{t('coursesPage.exerciseCount', { count: chapter.exerciseCount })}</small>
                <Link to={`/exercise/${chapter.firstExerciseId}`}>
                  {t('coursesPage.startChapter', { title: chapter.title })}
                </Link>
              </li>
            ))}
          </ul>
        ))}
    </section>
  );
}

export default CourseChapterMenu;
